import { StudentStage, User } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetParams {
  userId: User['id'];
}

const { useGet: useStudentStage } = getCRUDHooks<StudentStage, GetParams>({
  entityName: 'studentStage',
  get: ({ userId }: GetParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).studentStage.get(),
});

// eslint-disable-next-line import/prefer-default-export
export { useStudentStage };
